import { AriaTabPanel } from "@kazaar-platform/design-system";
import { useIsOMS } from "@/hooks/useIsOMS";
import { OrderItemSummary } from "./OrderItemSummary";
import { RushOrderBloc } from "./RushOrderBloc";
import { StatusActionsTabSkeleton } from "./StatusActionsTab.skeleton";
import { type StatusActionsTabProps } from "./StatusActionsTab.types";

export const StatusActionsTab = ({
  orderItem,
  setIsCancelModalOpen,
  isLoading,
  onTabNavigation,
}: StatusActionsTabProps) => {
  const isOMS = useIsOMS();

  const isFetching = isLoading || !orderItem;

  if (isFetching) {
    return <StatusActionsTabSkeleton />;
  }

  return (
    <AriaTabPanel id="information" style={{ flex: 1 }}>
      {!isOMS && (
        <RushOrderBloc
          orderItem={orderItem}
          setIsCancelModalOpen={setIsCancelModalOpen}
        />
      )}

      <OrderItemSummary
        orderItem={orderItem}
        onTabNavigation={onTabNavigation}
      />
    </AriaTabPanel>
  );
};
